exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_object-gops.js
// module id = 165
// module chunks = 17